import React, { PureComponent } from 'react'
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Button,
} from '@material-ui/core'
import RegionItem from './RegionItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { hasAccess } from '../../utils/api'
import { Appcues } from '../../utils/constants'
import RegionsCreate from './RegionsCreate'

const RegionItemEditable = EditableHOCWrapper(RegionItem)
const RegionCreate = EditableHOCWrapper(RegionsCreate)

const emptyRegion = {
  name: '',
  location: '',
  zipCodes: [],
  enabled: false,
  //TODO: add the rest of fields
}

export default class RegionsDispatchContainer extends PureComponent {
  state = {
    showEmptyRegion: false,
    flag: true,
  }

  toogleEmptyRegion = () => {
    Appcues.track('Adding Region')
    this.setState((prevState) => ({
      flag: false,
    }))
  }

  onSaveNew = (region, afterSave, kmlEdges) => {
    this.props.onSave(region, afterSave).then((res) => {
      Appcues.track('New Region saved')
      this.toogleEmptyRegion()
    })
  }

  //add route addregion
  addRegion = () => {
    this.props.history.push(`/settings/company/regions/add`)
  }

  render() {
    // console.log("props-container",this.props);
    const { showEmptyRegion = false, flag = true } = this.state
    const { regions = [], Geocode, lastModified, companyFeatures = {} } = this.props

    const { availableApps = [] } = companyFeatures

    const permitted = hasAccess()
    return (
      <Grid container>
        <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {flag ? (
                <Button
                  variant="raised"
                  className="primary-button pull-right margin-bottom-small"
                  //toogleEmptyRegion //addRegion
                  onClick={this.addRegion}
                >
                  Add Region
                </Button>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
        {flag ? (
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Region Name</TableCell>
                      <TableCell>Delivery Fee</TableCell>
                      <TableCell>Min Cart Subtotal Amount</TableCell>
                      <TableCell>Free Delivery After</TableCell>
                      <TableCell>Hours of Operations</TableCell>
                      <TableCell>Region Color</TableCell>
                      <TableCell>Default Region</TableCell>
                      <TableCell>Active</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {regions &&
                      regions.map((region, i) => {
                        return (
                          <RegionItemEditable
                            {...this.props} // add props
                            key={i}
                            dataToEdit={region}
                            Geocode={Geocode}
                            onDelete={this.props.onDelete}
                            onSave={this.props.onSave}
                            lastModified={lastModified}
                            locationChanged={lastModified}
                            flagv={flag}
                            companyFeatures={companyFeatures}
                          />
                        )
                      })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
        ) : (
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <RegionCreate
                dataToEdit={emptyRegion}
                lastModified={lastModified}
                onPinUpdate={this.addPin}
                onCancel={this.toogleEmptyRegion}
                defaultEditMode={true}
                Geocode={Geocode}
                onSave={this.onSaveNew}
                locationChanged={lastModified}
                companyFeatures={companyFeatures}
              />
            </Paper>
          </Grid>
        )}
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Regions/RegionsDispatchContainer.js